export type SelectOption<T = string> = {
    title: string;
    value: T;
};

export function sortOptionsByTitle<T>(options: SelectOption<T>[]): SelectOption<T>[] {
    return [...options].sort((a, b) => a.title.localeCompare(b.title));
}

export type VuetifySortByType =
    | readonly {
          key: string;
          order?: boolean | 'asc' | 'desc';
      }[]
    | undefined;

export type BackendSortOptionsType = {
    sortBy?: string;
    sortDirection?: boolean | 'asc' | 'desc';
};

export const transformSortBy = (vuetifySortBy: VuetifySortByType): BackendSortOptionsType => {
    if (!vuetifySortBy || vuetifySortBy.length === 0) {
        return {};
    }

    const firstSort = vuetifySortBy[0];

    return {
        sortBy: firstSort.key,
        sortDirection: firstSort.order,
    };
};

export function sortByDateField<T>(items: T[], field: keyof T, order: 'asc' | 'desc' = 'desc'): T[] {
    return [...items].sort((a, b) => {
        const dateA = new Date(a[field] as string).getTime();
        const dateB = new Date(b[field] as string).getTime();

        return order === 'desc' ? dateB - dateA : dateA - dateB;
    });
}
